<!--打印报表弹窗-->
<template>
  <el-dialog
    title=""
    class="large-padding half-print-container"
    :center="true"
    width="1000px"
    :modal="false"
    :visible="true"
    style="top: 100vh !important;"
  >
    <div
      ref="printContent"
      class="print-content-wrapper"
      :class="{ third: type.includes('三等分') }"
    >
      <div class="report-header">
        <div>
          <span class="hotelName">{{ hotelName }}</span>
        </div>
        <div>
          <span class="scale-9">{{ title }}</span>
        </div>
      </div>
      <div class="report-body half">
        <slot name="form"></slot>
        <slot></slot>
      </div>
      <el-row class="report-footer" :class="{ hasTable: isHasTable }">
        <el-col :span="4">
          <div class="footer-label">{{ $t('common.handledBy') }}</div>
          <div class="footer-text">{{ name }}</div>
        </el-col>
        <el-col :span="6">
          <div class="footer-label">{{ $t('common.printTime') }}</div>
          <div class="footer-text">{{ formateTimesStamp(undefined, 'ymd hm') }}</div>
        </el-col>
        <el-col :span="10">
          <div class="footer-label">{{ $t('common.address') }}</div>
          <div class="footer-text" :class="{ wrap: address.length > 16 }">{{ address }}</div>
        </el-col>
        <el-col :span="4">
          <div
            v-if="isNeedAuthorise"
            class="scale-8"
            style="margin-top: -6px; white-space: nowrap;"
          >
            {{ $t('common.signatureOfAuthorizer') }}
          </div>
          <div v-else style="visibility: hidden; line-height: 12px;">
            {{ $t('printsettingHalfprint.test') }}
          </div>
          <div class="scale-8">{{ signTitle }}</div>
        </el-col>
      </el-row>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button id="printBtn" type="primary" @click="refPrint('printContent')">{{
        $t('printsettingHalfprint.print')
      }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import i18n from '@/utils/i18n';
import { mapGetters } from 'vuex';
let triggerBtn = null;
let debounce = null;
export default {
  name: 'HalfPrint',
  model: {
    prop: 'printShow',
    event: 'close',
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    printShow: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    isNeedAuthorise: {
      type: Boolean,
      default: false,
    },
    tipText: {
      type: String,
      default: '',
    },
    signTitle: {
      type: String,
      default: i18n.t('common.signature3'),
    },
    address: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['name', 'hotelName']),
    isHasTable() {
      return this.type.includes('consumption_settle');
    },
  },
  updated() {
    this.$nextTick(() => {
      if (this.printShow && triggerBtn) {
        console.log(
          this.type.includes(this.$t('printsettingHalfprint.trisection'))
            ? this.$t('printsettingHalfprint.printInThirds')
            : this.$t('printsettingHalfprint.printInHalf')
        );
        if (debounce) {
          clearTimeout(debounce);
        }
        debounce = setTimeout(() => {
          triggerBtn.click();
          debounce = null;
        }, 1000);
      }
    });
  },
  mounted() {
    triggerBtn = document.getElementById('printBtn');
  },
};
</script>
<style lang="scss">
.third {
  .scale-9 {
    padding-top: 15px !important;
    padding-bottom: 10px !important;
  }
  .item-wrapper {
    margin-bottom: 5px !important;
    .font-content-label {
      margin-top: 0 !important;
    }
  }
}
</style>
<style lang="scss" scoped>
@media print {
  @page {
    margin-bottom: 10px;
  }
  .print-content-wrapper {
    width: 100%;
    overflow-x: hidden;
    padding: 10px 60px 0 60px;
  }
  .third {
    margin-top: -30px;
    /deep/ .report-table {
      margin-top: 0 !important;
    }
    .report-footer {
      margin-top: -10px !important;
      padding-top: 10px !important;
    }
  }
}
/deep/ .report-table {
  .el-table__empty-block {
    height: 30px !important;
    .el-table__empty-text {
      line-height: 30px !important;
    }
  }
  .el-table__empty-text {
    color: #000000;
  }
  .el-table__body {
    border: none !important;
    .el-table__row:nth-child(1) {
      td {
        border-top: 1px solid #000000 !important;
      }
    }
  }
  .el-table th.is-leaf {
    background: #fff !important;
    border-bottom: none !important;
  }
  .el-table__row:nth-child(2n),
  .el-table__footer-wrapper tbody td,
  .el-table__header-wrapper tbody td {
    background-color: #fff;
  }
  .el-table th.is-leaf {
    background: #fff;
    border-bottom: 2px solid #000000;
  }
  .el-table__row:nth-child(2n),
  .el-table__footer-wrapper tbody td,
  .el-table__header-wrapper tbody td {
    background-color: #fff;
  }
  .el-table td,
  .el-table th {
    padding: 6px 0 !important;
    border-bottom: 1px solid #000000;
  }
  .el-table__footer-wrapper td {
    border-top: 1px solid #000000 !important;
    border-bottom: none;
  }
}
.dot {
  display: inline-block;
  width: 15px;
  height: 15px;
  background: #2c3b4e;
  margin: 0 15px 6px 15px;
  border-radius: 50%;
}
.hotelName {
  display: inline-block;
  white-space: nowrap;
  font-size: 36px;
  color: #000000;
  vertical-align: super;
  margin-left: -4px;
  transform: scale(0.6) translateX(-32%);
}
.report-header {
  font-size: 30px;
  color: #000000;
  padding-top: 12px;
  .scale-9 {
    display: inline-block;
    font-size: 24px;
    color: #000000;
    padding-top: 50px;
    padding-bottom: 30px;
    margin-left: -2px;
    transform: scale(0.6) translateX(-32%);
  }
}
.report-footer {
  margin-top: 10px;
  padding-top: 15px;
  font-size: 30px;
  border-top: 1px solid #000000;
  color: #000000;
  &.hasTable {
    border-top: none;
  }
  .footer-label {
    font-size: 14px;
    transform: scale(0.6) translateX(-30%);
  }
  .footer-text {
    font-size: 16px;
    transform: scale(0.6) translateX(-30%);
    &.wrap {
      width: 150%;
      margin-top: -6px;
    }
  }
}
.scale-8 {
  font-size: 22px;
  color: #000000;
  transform: scale(0.6) translateX(-30%);
}
.authorise-sign {
  margin-top: 80px;
}
/deep/ .half-print-wrapper {
  .el-col {
    width: 20%;
  }
}
/deep/ .half {
  .el-table__footer-wrapper .cell,
  .cell-span {
    color: #000000;
    font-size: 18px !important;
    transform: scale(0.5) translateX(-50%);
    display: inline-block;
    font-weight: normal;
    line-height: 14px;
    padding-left: 4px;
  }
  .finance {
    margin: 10px 0 15px 0;
    .el-table__body-wrapper {
      .cell {
        min-height: 22px;
        padding: 0 !important;
        position: relative;
        overflow: visible;
      }
      .cell-span:not(.normal) {
        position: absolute;
        top: 0;
        left: 0;
        line-height: 1.3;
      }
      .normal {
        visibility: hidden;
      }
      .cell-span {
        width: 200%;
        &.multi-line {
          margin-bottom: 16px;
        }
      }
    }
  }
  .el-table__footer-wrapper .cell {
    font-size: 22px !important;
    line-height: initial;
    white-space: nowrap;
    padding-left: 4px;
  }
  th {
    .cell-span {
      font-size: 20px !important;
    }
  }
}
</style>
